import type { EditorSDK } from '@wix/wix-data-client-common-standalone'

export const getAppBaseUrl = async (
  editorSdkProxy: EditorSDK,
): Promise<string> => {
  const artifactUrls = await editorSdkProxy.info.getArtifactsUrls([
    'dbsm-editor-app',
  ])
  const appBaseUrl = artifactUrls['dbsm-editor-app']
  if (appBaseUrl.endsWith('/')) {
    return appBaseUrl.substr(0, appBaseUrl.length - 1)
  }
  return appBaseUrl
}
